import { postRestURL } from "../utils/constants/constants";

export async function getLegalText() {
    try {
        const response = await fetch(`${postRestURL}/legaltext`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}